// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Routing
import { SlideRoutingModule } from './slide-routing.module';
// Prime Ng
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PanelModule } from "primeng/panel";
import { InplaceModule } from "primeng/inplace";
// Medsurf Lib
import { FlatDesignModule } from '@medsurf/flat-designs';
import { MedsurfCommonModule } from '../common/medsurf-common.module';
// Components
import { AudioComponent } from './main/audio/audio.component';
import { ImageComponent } from './main/image/image.component';
import { SlideComponent } from './slide.component';
import { SlideMainComponent } from './main/slide-main.component';
import { VideoComponent } from './main/video/video.component';
// -- Toolbar
import { ToolbarComponent } from "./main/toolbar/toolbar.component"
// -- Wysiwyg
import { WysiwygComponent } from './wysiwyg/wysiwyg.component'
import { BodyComponent } from './wysiwyg/body/body.component';
import { WysiwygHeaderComponent } from './wysiwyg/header/wysiwyg-header.component';
import { InteractiveAreasComponent } from './wysiwyg/interactive-areas/interactive-areas.component';
import { PoisComponent } from './wysiwyg/pois/pois.component';
import { TitleComponent } from './main/toolbar/title/title.component';
import { SkeletonModule } from "primeng/skeleton";
// -- Questions
import { QuestionsComponent } from './wysiwyg/questions/questions.component';
import { FreetextQuestionComponent } from "./wysiwyg/questions/question-types/freetext-question/freetext-question.component";
import { IndicationQuestionComponent } from "./wysiwyg/questions/question-types/indication-question/indication-question.component";
import { KPrimQuestionComponent } from "./wysiwyg/questions/question-types/k-prim-question/k-prim-question.component";
import { KPrimQuestionChoiceComponent } from "./wysiwyg/questions/question-types/k-prim-question/k-prim-question-choice/k-prim-question-choice.component";
import { MappingQuestionComponent } from "./wysiwyg/questions/question-types/mapping-question/mapping-question.component";
import { MappingQuestionChoiceComponent } from "./wysiwyg/questions/question-types/mapping-question/mapping-question-choice/mapping-question-choice.component";
import { MappingQuestionSolutionComponent } from "./wysiwyg/questions/question-types/mapping-question/mapping-question-solution/mapping-question-solution.component";
import { SingleChoiceQuestionComponent } from "./wysiwyg/questions/question-types/single-choice-question/single-choice-question.component";
import { SingleChoiceQuestionChoiceComponent } from "./wysiwyg/questions/question-types/single-choice-question/single-choice-question-choice/single-choice-question-choice.component";
// -- Edit
import { EditComponent } from "./edit/edit.component";
// ---- Header
import { EditHeaderComponent } from "./edit/header/edit-header.component";
// ---- Bulk Edit
import { BulkEditComponent } from "./edit/bulk-edit/bulk-edit.component";
// ---- Group
import { GroupComponent } from './edit/group/group.component';
// ------ Group Annotation
import { GroupAnnotationFormComponent } from './edit/group/annotation-form/group-annotation-form.component';
// ---- Layer
import { LayerComponent } from './edit/layer/layer.component';
// ---- Poi
import { PoiComponent } from "./edit/poi/poi.component";
// ------ Poi Annotation
import { PoiAnnotationFormComponent } from "./edit/poi/annotation-form/poi-annotation-form.component";
// ------ Poi Image
import { PoiImageFormComponent } from "./edit/poi/image-form/poi-image-form.component";
// ---- Question
import { QuestionComponent } from "./edit/question/question.component";
// ---- Media
import { MediaComponent } from './edit/media/media.component';
// ------ Image Annotation
import { ImageAnnotationFormComponent } from "./edit/media/annotation-form/image-annotation-form.component";
// ------ Media Link
import { MediaLinkComponent } from './edit/media/media-link/media-link.component';
// ------ Image Poi
import { ImagePoiFormComponent } from './edit/media/poi-form/image-poi-form.component';
// ---- Metadata
import { MetadataComponent } from './edit/metadata/metadata.component';
// ---- Annotation
// ------ Marker
import { MarkerComponent } from './edit/annotation/marker/marker.component';
// ------ Keymap
import { KeymapComponent } from './edit/annotation/keymap/keymap.component';
import { KeymapColumnsComponent } from "./edit/annotation/keymap/columns/keymap-columns.component";
// ------ Free Form
import { FreeFormComponent } from './edit/annotation/free-form/free-form.component';
import { FreeFormFreeComponent } from "./edit/annotation/free-form/free/free-form-free.component";
import { FreeFormInteractiveAreaComponent } from "./edit/annotation/free-form/interactive-area/free-form-interactive-area.component";
import { FreeFormLineComponent } from './edit/annotation/free-form/line/free-form-line.component';
import { FreeFormShapeComponent } from './edit/annotation/free-form/shape/free-form-shape.component';
// ------ Forms
// ------ Marker
import { MarkerTargetsFormComponent } from './edit/annotation/marker/form/targets-form/marker-targets-form.component';
// ------ Keymap
import { KeymapFontStyleFormComponent } from "./edit/annotation/keymap/form/font-style-form/keymap-font-style-form.component";
import { KeymapLabelFormComponent } from "./edit/annotation/keymap/form/label-form/keymap-label-form.component";
import { KeymapSpacingStyleFormComponent } from "./edit/annotation/keymap/form/spacing-style-form/keymap-spacing-style-form.component";
// ------ Free Form
import { FreeFormBackgroundStyleFormComponent } from './edit/annotation/free-form/form/background-style-form/free-form-background-style-form.component';
import { FreeFormLineFormComponent } from './edit/annotation/free-form/form/line-form/free-form-line-form.component';
import { FreeFormLineStyleFormComponent } from './edit/annotation/free-form/form/line-style-form/free-form-line-style-form.component';
import { FreeFormPathFormComponent } from './edit/annotation/free-form/form/path-form/free-form-path-form.component';
import { FreeFormPointerFormComponent } from './edit/annotation/free-form/form/pointer-form/free-form-pointer-form.component';
import { FreeFormShapeFormComponent } from "./edit/annotation/free-form/form/shape-form/free-form-shape-form.component";
import { FreeFormTargetFormComponent } from './edit/annotation/free-form/form/target-form/free-form-target-form.component';
import { FreeFormTypeFormComponent } from './edit/annotation/free-form/form/type-form/free-form-type-form.component';
// ------ Shared Form
import { SharedDescriptionFormComponent } from './edit/annotation/shared/description-form/shared-description-form.component';
import { SharedGroupFormComponent } from './edit/annotation/shared/group-form/shared-group-form.component';
import { SharedImageFormComponent } from './edit/annotation/shared/image-form/shared-image-form.component';
import { SharedLinkFormComponent } from './edit/annotation/shared/link-form/shared-link-form.component';
import { SharedNameFormComponent } from './edit/annotation/shared/name-form/shared-name-form.component';
import { SharedPoiFormComponent } from './edit/annotation/shared/poi-form/shared-poi-form.component';
import { SharedSelftestFormComponent } from './edit/annotation/shared/selftest-form/shared-selftest-form.component';
import { SharedTextLayoutFormComponent } from './edit/annotation/shared/text-layout-form/shared-text-layout-form.component';

@NgModule({
	imports: [
		// Angular
		CommonModule,
		RouterModule,
		// Bootstrap
		NgbModule,
		// Translate
		TranslateModule.forChild(),
		// Routing
		SlideRoutingModule,
		// Modules
		MedsurfCommonModule,
		FlatDesignModule,
		SkeletonModule,
		OverlayPanelModule,
		PanelModule,
		InplaceModule,
	],
  declarations: [
    // Components
    AudioComponent,
    ImageComponent,
    SlideComponent,
    SlideMainComponent,
    VideoComponent,
    // -- Toolbar
    ToolbarComponent,
    // -- Wysiwyg
    WysiwygComponent,
    BodyComponent,
    WysiwygHeaderComponent,
	  InteractiveAreasComponent,
	  PoisComponent,
    // -- Questions
    QuestionsComponent,
    FreetextQuestionComponent,
    IndicationQuestionComponent,
    KPrimQuestionComponent,
    KPrimQuestionChoiceComponent,
    MappingQuestionComponent,
    MappingQuestionChoiceComponent,
    MappingQuestionSolutionComponent,
    SingleChoiceQuestionComponent,
    SingleChoiceQuestionChoiceComponent,
    // -- Edit
    EditComponent,
    // ---- Header
	  EditHeaderComponent,
	  // ---- Bulk Edit
	  BulkEditComponent,
    // ---- Group
    GroupComponent,
	  // ------ Group Annotation
	  GroupAnnotationFormComponent,
    // ---- Layer
    LayerComponent,
    // ---- Poi
    PoiComponent,
	  // ------ Poi Annotation
	  PoiAnnotationFormComponent,
	  // ------ Poi Image
	  PoiImageFormComponent,
	  // ---- Question
	  QuestionComponent,
    // ---- Media
    MediaComponent,
	  // ------ Image Annotation
	  ImageAnnotationFormComponent,
	  // ------ Media Link
	  MediaLinkComponent,
	  // ------ Image Poi
	  ImagePoiFormComponent,
    // ---- Metadata
    MetadataComponent,
    // ---- Annotation
    // ------ Marker
    MarkerComponent,
    // ------ Keymap
    KeymapComponent,
    KeymapColumnsComponent,
    // ------ Free Form
    FreeFormComponent,
    FreeFormFreeComponent,
    FreeFormInteractiveAreaComponent,
    FreeFormLineComponent,
    FreeFormShapeComponent,
    // ---- Forms
    // ------ Marker Form
    MarkerTargetsFormComponent,
    // ------ Keymap Form
    KeymapFontStyleFormComponent,
    KeymapLabelFormComponent,
    KeymapSpacingStyleFormComponent,
    // ------ Free Form
    FreeFormBackgroundStyleFormComponent,
    FreeFormLineStyleFormComponent,
    FreeFormLineFormComponent,
    FreeFormPathFormComponent,
    FreeFormPointerFormComponent,
    FreeFormShapeFormComponent,
    FreeFormTargetFormComponent,
    FreeFormTypeFormComponent,
    // ------ Shared From
	  SharedDescriptionFormComponent,
    SharedGroupFormComponent,
	  SharedImageFormComponent,
    SharedLinkFormComponent,
	  SharedNameFormComponent,
	  SharedPoiFormComponent,
	  SharedSelftestFormComponent,
	  SharedTextLayoutFormComponent,
    // -- Check these
    TitleComponent,
  ],
	exports: [
		// Components
		SlideComponent,
	]
})
export class SlideModule {
}
